import personal from './personal.js'
import system from './system.js'
import music from './music.js'
import other from './other.js'
import image from './image.js'
import chat from './chat.js'






var api = {}

api = Object.assign(
    api,
    personal,
    system,
    music,
    other,
    image,
    chat
)

export default api
